import React								from 'react';

import Badge 								from '../Badge';
import Button								from '../Button';

import {useAppSelector}						from '../../../app/hooks';

import {ExternalApiCardProps}				from './interface';

import {ft_setVarText}						from '../../functions/text';

import LANGUAGE								from '../../language';

import img_link								from '../../images/icon/link.svg';

import './ExternalApiCard.css';


function ExternalApiCard(props: ExternalApiCardProps): JSX.Element {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	let ACTIONS_LIST = [];

	if (!props.noConnect) {
		ACTIONS_LIST.push({
			value:  'connect',
			render: (
				<span className={'text-xs weight-600 gray-700'}>
					{ft_setVarText(TEXTE.global[props.isConnected ? 'reconnectTo' : 'connectTo'], TEXTE.component.externalApi[props.name])}
				</span>
			)
		});
	}

	ACTIONS_LIST = [...ACTIONS_LIST, ...props.actionList];

	let badgeText = TEXTE.global.notConnected;

	if (props.disabled)
		badgeText = TEXTE.global.soonAvailable;
	else if (props.isConnected)
		badgeText = TEXTE.global.connected;

	return (
		<div className={'globalDataContainerItem flex'} style={props.disabled ? {opacity: 0.5} : {}}>
			<div className={`externalApiCardLogo ${props.name}`} />

			<div className={'externalApiCardTextContainer'}>
				<div className={'text-md weight-600 gray-900'}>
					<span>{ft_setVarText(props.title, TEXTE.component.externalApi[props.name])}</span>
					<Badge
						size={'sm'}
						text={badgeText}
						color={props.isConnected ? 'success' : 'gray'}
					/>
				</div>
				<span>{ft_setVarText(props.text, TEXTE.component.externalApi[props.name])}</span>
				{props.learnMore &&
					<div className={'externalApiCardLearnMore'}>
						<span
							onClick={props.learnMore}
							className={'weight-500 primary-600'}
						>
							{TEXTE.devices.mdm.learnMore}
						</span>
					</div>
				}
			</div>

			<Button
				iconOnly
				absoluteRight
				absoluteHideIcon
				icon={img_link}
				type={'tertiary-gray'}
				absolute={ACTIONS_LIST}
				disabled={props.disabled}
				onChangeAbsolute={props.onClickAction}
			/>
		</div>
	);
}


export default ExternalApiCard;